import styled from 'styled-components';

export const TopBar = styled.div`
  padding: 1.6rem 2.4rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const Logo = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accentDark};
`;

export const Container = styled.div`
  max-width: 54rem;
  margin: 3.2rem auto;
  padding: 0 1.6rem;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.6rem;
  padding: 2.8rem;
`;

export const Title = styled.h2`
  font-size: 2.2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 0 0 1.2rem;
`;

export const Subtitle = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slate};
  line-height: 1.5;
  margin-bottom: 2rem;
`;

export const Input = styled.input`
  width: 100%;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1.2rem 1.4rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  box-sizing: border-box;
  font-family: inherit;
  margin-bottom: 1.6rem;
`;

export const CodeInput = styled.input`
  width: 100%;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1.6rem 1.4rem;
  font-size: 2.8rem;
  letter-spacing: 1.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.darkSlate};
  font-weight: 700;
  box-sizing: border-box;
  font-family: inherit;
  margin-bottom: 1.6rem;
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 8rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1rem 1.4rem;
  font-size: 1.4rem;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  margin-bottom: 1.2rem;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const FieldLabel = styled.div`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.slate};
  margin-top: 1.6rem;
  margin-bottom: 0.8rem;
`;

export const PrimaryBtn = styled.button`
  width: 100%;
  border: none;
  border-radius: 1.2rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.accentDark};
  cursor: pointer;
  margin-top: 0.8rem;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;

export const LinkBtn = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.accentDark};
  font-size: 1.3rem;
  font-weight: 600;
  margin-top: 1.2rem;
  cursor: pointer;
`;

export const ErrorText = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.errorDark};
  background-color: ${({ theme }) => theme.colors.errorBg};
  padding: 0.8rem 1.2rem;
  border-radius: 0.8rem;
  margin-bottom: 1.2rem;
`;

export const ReviewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1.2rem;
`;

export const ReviewRow = styled.button`
  text-align: left;
  padding: 1.4rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  cursor: pointer;
  font-family: inherit;
`;

export const ReviewService = styled.div`
  font-size: 1.3rem;
  font-style: italic;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.4rem;
`;

export const ReviewDate = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.2rem;
`;

export const ReviewComment = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slate};
  font-style: italic;
  margin-top: 0.6rem;
`;

export const EditHeader = styled.div`
  margin-bottom: 1.6rem;
`;

export const EditServiceName = styled.div`
  font-size: 1.5rem;
  font-style: italic;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.4rem;
`;

export const EditingHint = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const ToggleBox = styled.div`
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1.2rem 1.4rem;
  margin-bottom: 1.6rem;
`;

export const ToggleTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
`;

export const RadioRow = styled.label`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.6rem 0;
  cursor: pointer;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const SuccessBox = styled.div`
  text-align: center;
  padding: 1.6rem 0;
`;

export const SuccessIcon = styled.div`
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.accentDark};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3rem;
  margin: 0 auto 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.8rem;
`;

export const OriginalBox = styled.div`
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.2rem;
  padding: 1.6rem 1.8rem;
  margin-bottom: 2rem;
`;

export const OriginalHeading = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: 1rem;
`;

export const OriginalStarsRow = styled.div`
  margin-bottom: 0.6rem;
`;

export const OriginalText = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slate};
  font-style: italic;
  line-height: 1.5;
  margin-top: 0.6rem;
`;
